"use client";

import { getGlobalLookup } from "@faire/globals/deprecated/lookup";
import { messageToGibberish } from "@faire/localization/core/gibberish";
import type { StrictLocalizeFunction } from "@faire/localization/core/types";
import { LocalizationStore } from "@faire/localization/deprecated/LocalizationStore";
import { Language } from "@faire/types-localization-api/indigofair/languages/Language";
import { useCallback } from "react";
import { useIntl } from "react-intl";

export const useStrictLocalization = () => {
  const intl = useIntl();
  const { intl: legacyIntl, localeKey } = LocalizationStore.get();

  const strictLocalize: StrictLocalizeFunction = useCallback(
    (descriptor, values, opts) => {
      if (localeKey?.language === Language.STRING_ID) {
        return descriptor.id ?? "";
      }

      if (localeKey?.language === Language.GIBBERISH) {
        return intl.formatMessage(
          {
            defaultMessage: messageToGibberish(
              descriptor.defaultMessage as any
            ),
            id: descriptor.id,
          },
          values,
          opts
        );
      }

      return intl.formatMessage(
        /**
         * react-intl uses a different formatjs version than us.
         * The descriptor types don't perfectly match, but it should work fine.
         */
        descriptor as any,
        values,
        opts
      );
    },
    [intl, localeKey?.language]
  );

  const legacyStrictLocalize: StrictLocalizeFunction = useCallback(
    (descriptor, values, opts) =>
      legacyIntl.formatMessage(descriptor, values, opts),
    [legacyIntl]
  );

  // Return the named function for babel string extraction
  const lookup = getGlobalLookup();
  return {
    strictLocalize: lookup("isNextJS") ? strictLocalize : legacyStrictLocalize,
  };
};
